import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56e602de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.mode)
  }, [
    (!_ctx.customdesc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.img,
            alt: ""
          }, null, 8, _hoisted_2),
          (_ctx.emptyInfo)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.emptyInfo), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode("该股暂无" + _toDisplayString(_ctx.nodatadesc), 1),
                (_ctx.isShowSJ)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "数据"))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _ctx.img,
            alt: ""
          }, null, 8, _hoisted_7),
          _createElementVNode("span", null, _toDisplayString(_ctx.customdesc), 1)
        ]))
  ], 2))
}